export default class AutoRegister {
    constructor(registerPop, hasEmailLead) {
        this.registerPop = registerPop;
        this.count = 0;
        this.timerId = null;
        this.includeBlur = false;
        this.hasEmailLead = hasEmailLead;
        return this;
    }

    start() {
        this.offListener();
        this.registerPop.$EventBus.$on(
            'emailLead-register',
            this.startEmailLead.bind(this, true)
        );
        this.registerPop.$EventBus.$on(
            'vInput-change',
            this.onInputChange.bind(this)
        );
    }

    onInputChange(name, value, el) {
        //  must click first 'next' to receive out-of-focus events 
        if (!this.includeBlur) return;
        if (
            !['email', 'phone', 'fullname', 'lastName', 'firstName'].includes(
                name
            )
        ) {
            return;
        }
        if (!this.registerPop.$el.contains(el)) return;
        this.startEmailLead();
    }

    async startEmailLead(fromNextbt) {
        if (fromNextbt) this.includeBlur = true;
        //  Whether to register Email Lead  according to cms switch configuration 。 All registration entrances are unified 
        if (this.hasEmailLead) {
            if (this.registerPop.user) return; //  Logged in without processing 
            if (this.user) return;
            this.count++;
            if (this.timerId) {
                clearTimeout(this.timerId);
            }
            this.timerId = setTimeout(async () => {
                this.timerId = null;
                //  Data collection 
                let data = await this.getherData();
                //  Registration bullet box instance data sorting 
                const registerPop = this.registerPop;
                const registerOptions = this.registerPop.options || {};
                data = Object.assign(
                    registerOptions.registerData || {},
                    registerPop.step1Data || {},
                    data
                );
                if (data.email) {
                    this.registerPop[
                        this.registerPop.showThirdNext
                            ? 'thirdPartyAutoRegister'
                            : 'leadAutoRegister'
                    ](data);
                }
            }, 2000);
        }
    }

    async getherData() {
        //  of all registration forms form have to add ref
        let dataArr = await Promise.all(
            ['form', 'form-step1', 'form-step2', 'third-next']
                .map(k =>
                    k === 'third-next'
                        ? this.registerPop.$refs[k] &&
                          this.registerPop.$refs[k].$refs.form
                        : this.registerPop.$refs[k]
                )
                .filter(Boolean)
                .filter(f => f.validate)
                .map(formInstance => async () => {
                    //  Call the form instance validation data method to get the form data 
                    let result = await formInstance.validate(true);
                    let data = { ...formInstance.formData };
                    result.forEach(r => {
                        if (data[r.name] && (!r.valid || !r.value)) {
                            delete data[r.name];
                        }
                    });
                    return data;
                })
                .map(f => f())
        );
        return dataArr.reduce((finalData, d) => {
            return Object.assign(finalData, d);
        }, {});
    }

    offListener() {
        this.registerPop.$EventBus.$off(
            'emailLead-register',
            this.startEmailLead
        );
        this.registerPop.$EventBus.$off('vInput-change', this.onInputChange);
    }
}
const instances = new Map();

//  When the registration popup closes ， unlisten 
AutoRegister.prototype.destroy = function () {
    this.offListener();
    instances.delete(this.registerPop);
};

AutoRegister.getInstance = function (vm, hasEmailLead) {
    let instance = instances.get(vm);
    if (instance) return instance;
    instance = new AutoRegister(vm, hasEmailLead);
    instances.set(vm, instance);
    return instance;
};
